import { Box, Checkbox, FormControl, FormControlLabel, FormHelperText, Grid, MenuItem, Select, TextField, Typography } from '@mui/material'
import React, { useEffect } from 'react'
import FileUploadWrapper from '../../../Utils/FileUpload'

const BankDetailsForm = ({
    person,
    setPerson,
    handleUpload,
    confirmation_text,
    errors = {},
    isEdit = false,
    account_type
}) => {
    const handleChange = (field, value) => {
        setPerson(field, value);
    };
    useEffect(() => {
        if (!person.account_type && account_type.length > 0) {
            handleChange('account_type', account_type[0].value);
        }
    }, [account_type]);
    
  return (
    <Grid container spacing={2}>
        <Grid item xs={12} sm={12}>
            <Typography variant="body2" sx={{ fontSize: '13px', mb: 1, color: '#636363', fontWeight: 'bold' }}>Bank Account Number*</Typography>
            <TextField
                fullWidth
                size='small'
                value={person.account_number}
                onChange={(e) => {
                    const value = e.target.value;
                    if (/^\d*$/.test(value) && value.length <= 18) {
                        handleChange('account_number', value);
                    }
                }}
                
                sx={{
                    '& input': {
                        textTransform: 'uppercase',
                    },
                }}
                inputProps={{
                    inputMode: 'numeric',
                    maxLength: 18,
                }}
                error={ !!errors.account_number }
                helperText={ errors.account_number}
                type="text" 
            />
        </Grid>
        <Grid item xs={12} sm={12}>
            <Typography variant="body2" sx={{ fontSize: '13px', mb: 1, color: '#636363', fontWeight: 'bold' }}>IFSC*</Typography>
            <TextField
                fullWidth
                size='small'
                value={person.ifsc_code}
                onChange={(e) => handleChange('ifsc_code', e.target.value.toUpperCase())}
                sx={{
                    '& input': {
                        textTransform: 'uppercase',
                    },
                }}
                inputProps={{
                    maxLength: 13,
                }}
                error={!!errors.ifsc_code}
                helperText={errors.ifsc_code}
                type="text" 
            />
        </Grid>
        <Grid item xs={12} sm={12}>
            <Typography variant="body2" sx={{ fontSize: '13px', mb: 1, color: '#636363', fontWeight: 'bold' }}>Account Type*</Typography>
            <FormControl fullWidth>
                <Select
                    value={person.account_type || ''}
                    onChange={(e) => handleChange('account_type', e.target.value)}
                    size="small"
                    >
                    {account_type.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                        {option.label}
                        </MenuItem>
                    ))}
                </Select>
                <FormHelperText sx={{ color: '#CC0000' }}>{errors.account_type}</FormHelperText>
            </FormControl>
        </Grid>
        <Grid item xs={12} sm={12}>
            <Box display="flex" gap={2}>
                <Box flex={1} display="flex" flexDirection="column" justifyContent="space-between">
                    <FileUploadWrapper
                        title="Upload image of cancelled cheque*"
                        acceptedFileTypes={['image/png', 'image/jpeg','image/jpg', 'image/heic']}
                        handleUpload={handleUpload}
                        existingFileName={isEdit ? person.file_name : null}
                        existingFileUrl={isEdit ? person.id_str_base64 : null}
                    />
                </Box>
            </Box>
            {errors.id_str_base64 && (
                <FormHelperText sx={{ color: '#CC0000' }}>{errors.id_str_base64}</FormHelperText>
            )}
        </Grid>
        <Grid item xs={12}>
            <FormControlLabel sx={{ alignItems: 'flex-start' }}
                control={
                <Checkbox
                    checked={person.confirm || false}
                    onChange={(e) => handleChange('confirm', e.target.checked)}
                    sx={{ mr: 1, py:0}}
                />
                }
                label={confirmation_text?.label}
            />
            {errors.confirm && (
                <FormHelperText sx={{ color: '#CC0000' }}>{errors.confirm}</FormHelperText>
            )}
        </Grid>
    </Grid>
  )
}

export default BankDetailsForm